export enum EnvironmentEnum {
  LOCAL = 'local',
  DEVELOPMENT = 'development',
  STAG = 'staging',
  PROD = 'production',
}

export enum StorageEnum {
  ACCESS_TOKEN = 'access_token',
  REFRESH_TOKEN = 'refresh_token',
  USER = 'user',
  STATUS_LOGIN = 'statusLogin',
  ACCOUNT_ID = 'accountId',
  CANVAS_ACCOUNT_ID = 'canvasAccountId',
  DEVICE_ID = 'deviceId',
  ROLE = 'role',
  LANGUAGE = 'language',
}

export enum LanguageEnum {
  EN = 'en',
  IT = 'it',
  ES = 'es',
}

export enum ButtonTypeEnum {
  PRIMARY = 'primary',
  DANGER = 'danger',
}

export enum ResponseStatusEnum {
  SUCCESS = 'success',
  FAILED = 'failed',
  ERROR = 'error',
}

export enum MethodRequestServerEnum {
  GET = 'get',
}

export enum PaymentStatusEnum {
  WAITING_PAYMENT = 'WAITING_PAYMENT',
  PAYMENT_COMPLETED = 'PAYMENT_COMPLETED',
}

export enum TuitionStatusEnum {
  PAID = 'PAID',
  UNPAID = 'UNPAID',
}

export enum ExamStatusEnum {
  PASSED = 'PASS',
  FAILED = 'FAIL',
}
